angular.module( 'acme.view.application.themes.donation', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.themes.donation.controllers',
  'acme.view.application.dataGrid.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var themesDonation = {
        name: 'application.themes.config.donation',
        url: '/donation',
        views: {
          "subview-main": {
            controller: 'ThemesDonationController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/themes/donation/donation.tpl.html'
          }
        },
        data: {
          pageTitle: 'Theme - Donations',
          enablePreferences: true
        },
        resolve: {
          DonationData: [
            'AuthService',
            'ApiService',
            function(AuthService, ApiService) {
              return ApiService.textVariables.override.list();
            }
          ],
          UsersData: [
            'AuthService',
            'ApiService',
            function(AuthService, ApiService) {
              var props = {
                pageSize: 200,
                page: 1,
                sortField: 'name',
                sortDirection: 'asc'
              };
              return ApiService.userProxy.list(props, 'v2');
            }
          ]
        }
      };

    $stateProvider
      .state(themesDonation);
});
